import { HttpService } from '../services/http';

/**
 * Controller for checking the balance of a gift card. This code is used in conjunction with the template located in
 * this file:
 *
 * themes/stdcheck-exposed/templates/partial/stdcheck/gift-card-balance.twig
 */
export function GiftCardBalanceComponent() {
  const httpService = new HttpService();
  const form = document.getElementById('gift-card-balance-form');
  const errorContainer = document.getElementById('gift-card-error-container');
  const balanceContainer = document.getElementById('gift-card-balance-container');
  const submitButton = document.getElementById('gift-card-submit-button');

  // Initializes the component
  window.addEventListener('load', () => form.addEventListener('submit', (event) => checkGiftCardBalance(event)));

  /**
   * Checks the balance of a gift card and update the UI accordingly.
   *
   * @param {SubmitEvent} event the submit event object triggered by a form submission
   */
  function checkGiftCardBalance(event) {
    event.preventDefault();
    submitButton.disabled = true;
    setErrorMessage('');
    setGiftCardBalance('', '');
    const giftCardCode = event.target.elements['gift-card-code'].value;
    if (!isGiftCardCodeValid(giftCardCode)) {
      setErrorMessage('The code you entered is not valid. Please double check your gift card code.');
      submitButton.disabled = false;

      return;
    }

    httpService
      .get(`${process.env.API_URL}/api/v1/gift-card-balance/${giftCardCode}`)
      .then((response) => setGiftCardBalance(giftCardCode, response.balance))
      .catch(() => {
        const errorMessage =
          'Invalid. We do not have any record of your gift card. If you feel this is an error, ' +
          'please contact customer service at 1-800-456-2323.';

        setErrorMessage(errorMessage);
      })
      .finally(() => (submitButton.disabled = false));
  }

  /**
   * Checks if a gift card code is valid.
   *
   * @param {string} giftCardCode the gift card code to validate
   *
   * @returns {boolean} true if the gift card code is valid, false otherwise
   */
  function isGiftCardCodeValid(giftCardCode) {
    if (!giftCardCode || giftCardCode.length !== 6) {
      return false;
    }

    return true;
  }

  /**
   * Sets an error message on the webpage and toggles its visibility.
   *
   * @param {string} message the error message to display
   */
  function setErrorMessage(message) {
    errorContainer.innerHTML = `<span class="fa fa-exclamation-circle"></span> ${message}`;
    if (message) {
      errorContainer.classList.remove('hide');

      return;
    }

    errorContainer.classList.add('hide');
  }

  /**
   * Updates the displayed gift card balance on the webpage and toggles its visibility.
   *
   * @param {string} giftCardCode the code of the gift card
   * @param {string} balance the balance amount of the gift card
   */
  function setGiftCardBalance(giftCardCode, balance) {
    balanceContainer.innerHTML = `<span class="fa fa-check"></span> Your gift card "${giftCardCode}" balance is $${balance}.`;
    if (balance && giftCardCode) {
      balanceContainer.classList.remove('hide');

      return;
    }

    balanceContainer.classList.add('hide');
  }
}

window.giftCardBalance = new GiftCardBalanceComponent();
